import { FLASHLIGHT_GESTURE_KEY_BY_MODEL } from '@mxa-argos/modules/forja/constants/forja.constants';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import type { ForjaDeviceSession } from '@mxa-argos/modules/forja/lib/engine/forja-device-session';
import { ForjaError } from '@mxa-argos/modules/forja/lib/forja-error';

export function flashlightGestureStep(): ForjaStep {
  let resolvedKey: string | null = null;

  const gestureKey = async (device: ForjaDeviceSession): Promise<string> => {
    if (!resolvedKey) {
      resolvedKey = await resolveGestureKey(device);
    }

    return resolvedKey;
  };

  return {
    name: 'quick flashlight gesture off',
    verify: async (device) => {
      const key = await gestureKey(device);

      return device.shell('settings', 'get', 'secure', key).then((value) => value === '0');
    },
    apply: async (device) => {
      const key = await gestureKey(device);

      await device.shell('settings', 'put', 'secure', key, '0');
    },
    verifyTimeoutMs: 5_000,
  };
}

async function resolveGestureKey(device: ForjaDeviceSession): Promise<string> {
  const model = await device.shell('getprop', 'ro.product.device');
  const key = FLASHLIGHT_GESTURE_KEY_BY_MODEL[model];

  if (!key) {
    throw new ForjaError(
      'UNKNOWN_DEVICE_MODEL',
      `no flashlight gesture key known for '${model}'; known models: ${Object.keys(FLASHLIGHT_GESTURE_KEY_BY_MODEL).join(', ')}`,
    );
  }

  return key;
}
